import React from "react"
import { Route, Redirect } from "react-router-dom"
import Auth from "./Auth"
import { getPermissionSize } from "../Permissions"
import { withRouter } from 'react-router-dom';


class AuthorRoute extends React.Component {
  state = {
    auth: false,
    loading: true,
    error: "",
  }

  async componentDidMount() {
    const response = await Auth.authCheck(this.props.permission ? parseInt(this.props.permission) : (1 << getPermissionSize()) - 1)
    if(response.archived) {
      this.props.history.push('/CollegeDashboard')
    }
    if (response.authenticated) {
      this.setState({ auth: true })
    }
    this.setState({ error: response.error })
    this.setState({ loading: false })
  }

  async componentDidUpdate(prevProps) {
    // check for a new location change
    if (this.props.location !== prevProps.location) {
      const response = await Auth.authCheck(this.props.permission ? parseInt(this.props.permission) : (1 << getPermissionSize()) - 1)
      // console.log("response 2: ", response, this.props.location)
      if(response.archived) {
        this.props.history.push('/CollegeDashboard')
      }
      if (response.authenticated) {
        this.setState({ auth: true })
      }
      else {
        this.setState({ auth: false })
      }
      this.setState({ error: response.error })
      this.setState({ loading: false })
    }
  }

  render() {
    const { loading, auth } = this.state
    // console.log(loading, auth)
    if (!loading && !auth) {
      if (window.location.pathname.includes('ViewCalendar')) {
        const params = (new URL(document.location)).searchParams;
        const teacher_id = params.get("teacher_id");
        teacher_id && localStorage.setItem("teacher_id", teacher_id);
      }

      return (
        <Redirect
          to={{
            pathname: "/LoginAsInstitution",
            state: {
              error: this.state.error,
            },
          }}
        />
      )
    } else {
      return (
        !loading && (
          (this.props.component) ?
            <Route
              exact={this.props.exact}
              path={this.props.path}
              component={this.props.component}
            /> :
            <Route
              exact={this.props.exact}
              path={this.props.path}
              render={this.props.render}
            />
        )
      )
    }
  }
}
export default withRouter(AuthorRoute);
// export default AuthorRoute
